import { Record, Resource, SDK } from '@redge-media/fo-js-sdk';

const Search = Resource.extend({
  endpoint: '/items/search',

  constructor: function Search() {
    Resource.call(this);

    this.meta = {};
    this.pending = {};
  },

  deserialize(response, opts = {}) {
    const data = Resource.prototype.deserialize(response, opts);
    const type = data.items[0] && data.items[0].type;

    if (type) {
      this.meta[type] = data.meta;
    }

    return data.items;
  },

  createRecord(props = {}, opts = {}) {
    if (props instanceof Record) {
      return props;
    }

    return SDK.factory.resolve(props, opts);
  },
});

export default Search;
